<!--
 * @Description: What's this for
 * @Autor: WangYuan
 * @Date: 2021-08-12 17:23:08
 * @LastEditors: WangYuan
 * @LastEditTime: 2021-08-31 20:12:08
-->
<template>
  <!--  <el-dialog :visible.sync="dialogVisible"
             :close-on-click-modal="false" title="请选择跳转页面" width="800px"
             :before-close="handleClose"
  >-->

  <el-dialog
      append-to-body
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="请选择跳转页面"
      width="800px"
      @before-close="handleClose"
  >
    <div class="list mb30">
      <div
          v-for="(tab, i) in list"
          :key="i"
          :class="[value.type == tab.type ? 'tab-active' : '']"
          class="tab flex-center"
          @click="changeTab(tab.type)"
      >
        {{ tab.label }}
      </div>
    </div>

    <!-- 站内链接 -->
    <template v-if="value.type == 'insid'">
      <!--左侧-->
      <div class="pageContent">
        <div class="left" style="height: 300px; overflow-x: scroll">
          <div
              v-for="(item, index) in dataList"
              :key="index"
              :class="curClickPage.pagesId == item.pagesId ? 'cur' : 'nor'"
              @click="getPoints(item, false)"
          >
            {{ item.name }}
          </div>
        </div>

        <div class="right">
          <div v-if="curClickPage.linkPoints || curClickPage.dsInitParams">
            <div class="points" v-if="curClickPage.linkPoints">
              <div class="points-tit">
                选择
                <span
                    v-if="
                    curClickPage &&
                    curClickPage.linkPoints &&
                    JSON.parse(curClickPage.linkPoints)[0] &&
                    JSON.parse(curClickPage.linkPoints)[0]['title']
                  "
                >
                  {{ JSON.parse(curClickPage.linkPoints)[0]["title"] }}
                </span>
              </div>
              <div class="points-cates">
                <span
                    v-for="(item, index) in pointsList"
                    :key="index"
                    :class="curPoint.value == item.value ? 'cate curCate' : 'cate'"
                    @click="btnPoint(item)"
                >
                  {{ item[showName] }}
                </span>
              </div>
            </div>

            <!--树形菜单二级和三级呈现形式-->
            <div
                class="points-cates"
                v-if="
                curPoint.value &&
                JSON.parse(curClickPage.linkPoints)[0].showLevel &&
                JSON.parse(curClickPage.linkPoints)[0].showLevel != 1 &&
                curPoint['children'] &&
                curPoint['children'].length > 0
              "
            >
              <p style="margin-bottom: 15px">选择"{{ curPoint[showName] }}"的子级</p>
              <span
                  v-for="(item, index) in curPoint['children']"
                  :key="index"
                  :class="curSecondPoint.value == item[clickId] ? 'cate curCate' : 'cate'"
                  @click="
                  btnPointSecondTree(
                    item,
                    JSON.parse(curClickPage.linkPoints)[0].children
                  )
                "
              >
                {{ item[showName] }}
              </span>
            </div>

            <div
                class="points-cates"
                v-if="
                curSecondPoint.value &&
                JSON.parse(curClickPage.linkPoints)[0].showLevel &&
                JSON.parse(curClickPage.linkPoints)[0].showLevel == 3 &&
                curSecondPoint['children'] &&
                curSecondPoint['children'].length > 0
              "
            >
              <p style="margin-bottom: 15px">
                选择"{{ curSecondPoint[showName] }}"的子级
              </p>

              <span
                  v-for="(item, index) in curSecondPoint['children']"
                  :key="index"
                  :class="curThreePoint.value == item[clickId] ? 'cate curCate' : 'cate'"
                  @click="
                  btnPointThreeTree(item, JSON.parse(curClickPage.linkPoints)[0].children)
                "
              >
                {{ item[showName] }}
              </span>
            </div>

            <div class="points-cates" v-if="curPoint.value && getSecondeList.length > 0">
              <p style="margin-bottom: 15px">二级导航选择项</p>
              <span
                  v-for="(item, index) in getSecondeList"
                  :key="index"
                  :class="tableSecondIndex == index ? 'cate curCate' : 'cate'"
                  @click="btnPointSecond(item, index)"
              >
                {{ item.name }}
              </span>
            </div>

            <div v-if="curClickPage.dsInitParams">
              <el-tabs type="border-card">
                <el-tab-pane
                    :label="item.title"
                    v-for="(item, index) in dsInitParams"
                    :key="index"
                >
                  <div class="points-tit">
                    选择{{ item.title ? item.title : "" }}({{
                      item.required ? "必填" : "非必填"
                    }})
                  </div>

                  <div
                      v-if="
                      item.showType == 'show_tree' &&
                      item.dataList.length > 0 &&
                      item.dataMapper
                    "
                  >
                    <el-tree
                        :key="'tree-' + index + '-' + dialogVisible"
                        ref="tree"
                        :data="item.dataList"
                        show-checkbox
                        check-strictly
                        check-on-click-node
                        default-expand-all
                        :node-key="item.relationField"
                        highlight-current
                        :props="{
                        children: item.dataMapper?.children?.source || 'children',
                        label: 'name',
                      }"
                        @check="
                        (node, checkedNode) =>
                          handleCheckChange(
                            node,
                            checkedNode,
                            item.relationField,
                            index,
                            item.params
                          )
                      "
                    >
                    </el-tree>
                  </div>

                  <div v-else>
                    <el-table
                        ref="insidTable"
                        :data="item.dataList"
                        :row-key="getRowKey"
                        class="insidTab"
                        size="mini"
                        stripe
                        max-height="500"
                        :show-header="false"
                    >
                      <el-table-column
                          align="center"
                          reserve-selection
                          type="selection"
                          width="55"
                      >
                        <template slot-scope="scope">
                          <input
                              type="checkBox"
                              :checked="scope.row[item.relationField] == item.curChoose"
                              @click="btnClickParams(index, scope.row[item.relationField])"
                          />
                        </template>
                      </el-table-column>

                      <el-table-column
                          :label="items.targetName"
                          :prop="items.source"
                          class-name="custom-cell"
                          v-for="(items, indexs) in item.dataMapper"
                          :key="indexs"
                      >
                      </el-table-column>
                    </el-table>

                    <el-pagination
                        @size-change="handleSizeChange(index, item, $event)"
                        @current-change="handleCurrentChange(index, item, $event)"
                        :current-page="item.current"
                        :page-size="item.size"
                        :pager-count="5"
                        :page-sizes="[10, 20, 50, 100, 200]"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="item.total"
                        v-if="item.needPage == 1"
                        background
                        class="pagina mt15"
                    >
                    </el-pagination>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>
        </div>
      </div>
    </template>

    <!-- 站外链接 -->
    <template v-if="value.type == 'link'">
      <el-form ref="form" :model="value" label-width="80px">
        <el-form-item label="跳转方式" prop="mode">
          <el-radio-group v-model="value.mode">
            <el-radio label="1">H5跳转</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="" prop="mode">
          <el-input
              v-model="value.id"
              placeholder="请输入h5跳转链接"
              size="mini"
              style="width: 250px"
          ></el-input>
        </el-form-item>
      </el-form>
    </template>

    <!-- 跳转小程序 -->
    <template v-if="value.type == 'applet'">
      <el-form ref="form" :model="value" label-width="80px">
        <el-form-item label="跳转方式:" prop="mode">
          <el-radio-group v-model="value.mode">
            <el-radio label="1">常规跳转</el-radio>
            <el-radio label="2">微信半屏小程序</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="App ID:" prop="mode">
          <el-input
              v-model="value.id"
              @input="bindInput($event, 'appId')"
              placeholder="请输入小程序APPID"
              size="mini"
              style="width: 250px"
          ></el-input>
        </el-form-item>
        <el-form-item label="路径:" prop="mode">
          <el-input
              v-model="value.data.jump"
              @input="bindInput($event, 'path')"
              placeholder="请输入跳转链接"
              size="mini"
              style="width: 250px"
          ></el-input>
        </el-form-item>
      </el-form>
    </template>

    <div slot="footer" class="dialog-footer">
      <el-button @click="bindColse">取 消</el-button>
      <el-button type="primary" @click="bindConfirm">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";
import { getFormPage } from "@/api/project";
import { getCategoryList, datasourcePage, getCategoryListPost } from "@/api/easyApp";
import { deepClone } from "../../../js/utils";

export default {
  name: "JumpDialogView",
  // inject: ["value"],
  data() {
    return {
      lastCheckedNode: null,
      list: [
        { label: "站内链接", type: "insid" },
        { label: "站外链接", type: "link" },
        { label: "跳转小程序", type: "applet" },
        { label: "不跳转", type: undefined },
      ],
      dataList: [],
      totalPage: 0,
      dialogVisible: false,
      dataListLoading: false,
      queryForm: {
        aid: "",
        size: 100,
        current: 1,
      },
      curActive: "", //点击过的点位
      pointsList: [], //点位列表
      curClickPage: {
        pagesId: "",
      },
      clickId: "",
      showName: "",
      curPoint: {
        value: "",
      },
      initData: [],
      dsInitParams: [],

      valueOld: {},
      value: {
        data: {},
        id: "",
        linkPoint: null,
        initParams: [],
        type: "insid",
      },

      linkPointsList: [], //点位链接数组
      secondLinkPointId: "",
      tableSecondIndex: -1,

      curSecondPoint: {
        value: "",
      },
      curThreePoint: {
        value: "",
      },
      //secondTreeLinkPointId: "",
      //tableSecondTreeIndex: -1,
    };
  },

  props: {
    linkList: {
      default: () => [],
    },
  },
  computed: {
    ...mapGetters(["project", "fixedPages"]),
    customPages() {
      return this.project.pagesEntityList;
    },

    getSecondeList() {
      let idList = [];
      console.log(this.pointsList);
      if (
          this.pointsList[this.curPoint.value] &&
          this.pointsList[this.curPoint.value].components &&
          Array.isArray(this.pointsList[this.curPoint.value].components)
      ) {
        this.pointsList[this.curPoint.value].components.forEach((element) => {
          idList = idList.concat(element.split("-"));
        });
        let retunList = [];
        idList.forEach((item) => {
          this.linkPointsList.forEach((item2) => {
            if (item == item2.id) {
              this.secondLinkPointId = item2.id;
              retunList = item2.data;
            }
          });
        });
        return retunList;
      } else {
        return [];
      }
    },
  },

  methods: {
    bindInput(val, key) {
      if (key == "appId") {
        this.value.id = val;
      } else {
        this.value.data.jump = val;
      }
      this.$forceUpdate();
    },

    //关闭弹框
    handleClose() {
      //需要判断下必填参数必须选完
      if (this.dsInitParams) {
        for (const i in this.dsInitParams) {
          let index = this.dsInitParams.findIndex(
              (item) => item.curChoose != null && item.curChoose != ""
          );
          if (
              this.dsInitParams[i].required &&
              !this.dsInitParams[i].curChoose &&
              index == -1
          ) {
            this.$message({
              message: "请选择一个必填条件",
              type: "error",
            });
            return;
          }
        }

        this.dialogVisible = false;
      } else {
        this.dialogVisible = false;
      }
      // 恢复 value 到初始状态，确保下次打开弹窗时显示正确的勾选状态
      if (this.valueOld) {
        this.value = deepClone(this.valueOld);
        // 同步恢复 dsInitParams 中的 curChoose 属性
        if (this.dsInitParams && this.value.initParams) {
          this.dsInitParams.forEach((item) => {
            item.curChoose = "";
          });
          this.value.initParams.forEach((initParam) => {
            const index = this.dsInitParams.findIndex(
                (item) => item.componentId == initParam.componentId
            );
            if (index != -1) {
              const relationField = initParam["relationField"];
              this.dsInitParams[index].curChoose = initParam[relationField] || "";
            }
          });
        }
      }
      this.$forceUpdate();
    },

    btnChoose(item) {
      this.curActive = item.value;
    },

    //获取点位列表
    async getPoints(item, init) {
      //初始化的时候不用处理东西
      if (!init) {
        let index = -1;
        if (this.value.id) {
          index = this.value.id.indexOf(item.pagesId);
        }
        if (index !== -1) {
          this.value.data = {};
          this.value.id = "";
        } else {
          this.value.data = {
            aid: item.aid,
            home: item.home,
            name: item.name,
            pagesId: item.pagesId,
            sign: item.sign,
          };
          this.value.id = item.pagesId;
        }
        this.tableSecondIndex = -1;

        this.value.linkPoint = null;
        this.value.initParams = [];
        this.curPoint = { value: "" };
        this.curSecondPoint = { value: "" };
        this.curThreePoint = { value: "" };
        this.secondLinkPointId = "";
      }

      this.curClickPage = item;

      this.linkPointsList = JSON.parse(this.curClickPage.linkPoints);

      if (item.linkPoints) {
        this.clickId = JSON.parse(item.linkPoints)[0].sign;
        this.showName = JSON.parse(item.linkPoints)[0].name;

        if (JSON.parse(item.linkPoints)[0]["type"] == "remote") {

          let data = {
            url: JSON.parse(item.linkPoints)[0].url=='/form/category/condition/tree'||
            JSON.parse(item.linkPoints)[0].url=='form/category/condition/tree'?
                '/form/category/condition/tree?type=1':JSON.parse(item.linkPoints)[0].url,
          };


          let res = await getCategoryList(data);
          let list = [];
          for (const i in res.data) {
            let obj = {
              sign: this.clickId,
              value: res.data[i][this.clickId],
              name: res.data[i][this.showName],
            };
            if (
                JSON.parse(item.linkPoints)[0].showLevel &&
                (JSON.parse(item.linkPoints)[0].showLevel == 2 ||
                    JSON.parse(item.linkPoints)[0].showLevel == 3)
            ) {
              let children = JSON.parse(item.linkPoints)[0].children;
              obj["children"] = res.data[i][children];
            }
            list.push(obj);
          }
          if (JSON.parse(item.linkPoints)[0].groupModel) {
            let obj = {};
            obj["sign"] = this.clickId;
            obj["value"] = "123456";
            obj["name"] = "全部";
            obj["children"] = [];
            list.unshift(obj);
          }
          this.pointsList = list;
        } else {
          this.pointsList = JSON.parse(item.linkPoints)[0]["data"];
        }

        if (init && this.value.linkPoint) {
          this.curPoint = deepClone(this.value.linkPoint);

          if (this.curPoint.secondTreeLinkPoint) {
            let index = this.pointsList.findIndex(
                (item) => item.value == this.curPoint.value
            );
            if (index != -1) {
              //console.log("index:",index,this.pointsList[index]);
              this.curSecondPoint = deepClone(this.curPoint.secondTreeLinkPoint);
              this.curPoint["children"] = deepClone(this.pointsList[index].children);

              if (this.curPoint.threeTreeLinkPoint && this.curPoint["children"]) {
                let secondIndex = this.curPoint["children"].findIndex(
                    (item) => item[this.clickId] == this.curSecondPoint.value
                );

                //console.log("secondIndex:",secondIndex);

                let children = JSON.parse(item.linkPoints)[0].children;
                // console.log("children:",children);
                if (secondIndex != -1) {
                  this.curSecondPoint["children"] = this.curPoint["children"][
                      secondIndex
                      ][children];
                  //console.log("this.curPoint['children'][secondIndex][children]:",this.curPoint['children'][secondIndex][children]);
                  //console.log("this.curSecondPoint:",this.curSecondPoint);
                  this.curThreePoint = deepClone(this.curPoint.threeTreeLinkPoint);
                }
                // this.curSecondPoint[children]=

                //this.curThreePoint=deepClone(this.curPoint.threeTreeLinkPoint);
              }
            }
          }

          if (this.value.linkPoint && this.value.linkPoint.secondLinkPoint) {
            this.tableSecondIndex = Number(this.value.linkPoint.secondLinkPoint.value);
            this.secondLinkPointId = this.value.linkPoint.secondLinkPoint.id;
          }
        }
      } else {
        this.pointsList = [];
      }

      //得到初始化参数 获取数据
      if (item.dsInitParams) {
        let dsInitParams = JSON.parse(item.dsInitParams);

        let code = [];
        let initList = [];
        let initDictList = [];
        //let alldata

        //useDictDs
        for (const i in dsInitParams) {
          dsInitParams[i].relationParams = JSON.parse(dsInitParams[i].relationParams);

          let normalParams = dsInitParams[i].relationParams.filter(
              (item) => (item.useDictDs&&item.useDictDs != true)||(item.paramType&&item.paramType!='dict')
          );

          let dict = dsInitParams[i].relationParams.filter(
              (item) => (item.useDictDs&&item.useDictDs == true)||(item.paramType&&item.paramType=='dict')
          );
          // let dsInitParamsCode=[];

          console.log("normalParams:",normalParams);

          for (const j in normalParams) {

            if(normalParams[j]["dsName"]){
              code.push(normalParams[j]["dsName"]);
            }
            else{
              code.push(normalParams[j]["relationDS"]);
            }


            const dataMapperIndex = this.linkList.findIndex(
                (item) => item.code == normalParams[j]["dsName"]||item.code==normalParams[j]["relationDS"]
            );

            console.log("dataMapperIndex:",dataMapperIndex,this.linkList,normalParams[j]);

            let dataMapper = [];

            if (dataMapperIndex != -1) {
              dataMapper = this.linkList[dataMapperIndex].dataMapperList[0][
                  "configContent"
                  ];
              dataMapper = JSON.parse(dataMapper);
            }

            let obj = {
              code: normalParams[j]["dsName"]?normalParams[j]["dsName"]:normalParams[j]["relationDS"],
              componentId: dsInitParams[i].componentId,
              componentIdCode:normalParams[j]["dsName"]?
                  dsInitParams[i].componentId + "*" + normalParams[j]["dsName"]:
                  dsInitParams[i].componentId + "*" + normalParams[j]["relationDS"],
              dataMapper: dataMapper,
              // decRule:dsInitParams[i].decRule,
              name: normalParams[j]["name"], //传递的
              relationField: normalParams[j]["dsField"]?normalParams[j]["dsField"]:normalParams[j]["relationField"], //勾选的
              required: normalParams[j].required,
              current: 1,
              size: 10,
              dataList: [],
              pages: 0,
              total: 0,
              curChoose: "",
              url: "",
              title: "",
              needPage: 0,
            };

            //修改bug
            initList.push(obj);
          }

          for (const j in dict) {
            let objNew = {
              code: "",
              componentId: dsInitParams[i].componentId + "*dict" + initDictList.length,
              //componentIdCode: dsInitParams[i].componentId + '*' + normalParams[j]['relationDS'],
              componentIdCode: "",
              /*componentId: 'dict'+initDictList.length,
                componentIdCode: '',*/
              dataMapper: {
                label: {
                  source: "label",
                  sourceName: dict[j].dictDs.name,
                },
              },
              name: dict[j].name,
              relationField: "value",
              required: dict[j].required,
              current: 1,
              size: 10,
              dataList: JSON.parse(dict[j].dictDs.items),
              pages: 0,
              total: 0,
              curChoose: "",
              url: "",
              title: dict[j].dictDs.name,
              needPage: 0,
            };

            initDictList.push(objNew);
          }
        }

        let data = {
          codes: code.toString(),
          current: 1,
          size: 100,
        };
        let res = await datasourcePage(data);
        let records = res.data.records;

        if (records && records.length > 0) {
          for (const i in initList) {
            let obj = {
              current: 1,
              size: 10,
              dataList: [],
              pages: 0,
              code: records[i].code,
              total: 0,
            };

            let result = await this.getInitData(obj, records[i].url, records[i].method);

            initList[i].needPage = records[i].needPage;
            initList[i].showType = records[i].showType;
            if (records[i].params) {
              //  JSON.parse(records[i].params) 最开始给的数组，所以取0
              // console.log("124124", JSON.parse(records[i].params));
              initList[i].params = JSON.parse(records[i].params)[0];
            }

            if (records[i].needPage == 1) {
              initList[i].dataList = result.records;
              initList[i].pages = result.pages;
              initList[i].total = result.total;
            } else {
              initList[i].dataList = result;
            }

            initList[i].url = records[i].url;
            initList[i].title = records[i].name;
            initList[i].method = records[i].method;
          }
        }

        if (initDictList.length > 0) {
          this.dsInitParams = [...initDictList, ...initList];
        } else {
          this.dsInitParams = initList;
        }

        if (init && this.value.initParams) {
          console.log("===getPoints initParams restore=== START ====");
          console.log("===getPoints initParams restore=== this.value.initParams:", JSON.stringify(this.value.initParams));
          for (const i in this.value.initParams) {
            const initParam = this.value.initParams[i];
            console.log("===getPoints initParams restore=== processing initParam:", JSON.stringify(initParam));
            let index = this.dsInitParams.findIndex(
                (item) => item.componentId == initParam.componentId
            );
            console.log("===getPoints initParams restore=== found index:", index);
            if (index != -1) {
              const relationField = initParam["relationField"];
              const value = initParam[relationField];
              console.log("===getPoints initParams restore=== setting curChoose:", value, "for componentId:", initParam.componentId);
              this.dsInitParams[index].curChoose = value;
            }
          }
          console.log("===getPoints initParams restore=== END ====");
        }
      } else {
        this.dsInitParams = [];
      }

      //树形初始化选中
      console.log("===getPoints tree init=== this.value.initParams:", JSON.stringify(this.value.initParams));
      if (this.value.initParams && this.value.initParams.length > 0) {
        this.value.initParams.forEach((item, treeIndex) => {
          let index = this.dsInitParams.findIndex(
              (item2) => item.componentId == item2.componentId
          );
          if (
              index > -1 &&
              this.dsInitParams[index].showType == "show_tree" &&
              item[this.dsInitParams[index].relationField]
            ) {
            let idList = item[this.dsInitParams[index].relationField].split(",");
            console.log("===getPoints tree init=== setting checkedKeys:", idList, "for tree index:", index);
            this.$nextTick(() => {
              if (this.$refs.tree && this.$refs.tree[index]) {
                this.$refs.tree[index].setCheckedKeys(idList);
              }
            });
          }
        });
      } else {
        // 如果没有选中项，清除所有树形勾选状态
        console.log("===getPoints tree init=== no initParams, clearing all tree checked keys");
        this.$nextTick(() => {
          if (this.$refs.tree && Array.isArray(this.$refs.tree)) {
            this.$refs.tree.forEach((tree, idx) => {
              if (tree) {
                tree.setCheckedKeys([]);
              }
            });
          }
        });
      }
      console.log(this.curClickPage);
      console.log(this.dsInitParams);
    },





    async getInitData(obj, url, method) {
      if (method == "post" || method == "POST") {
        let data = {
          current: obj.current,
          size: obj.size,
          url: url=='/form/category/condition/tree'||url=='form/category/condition/tree'?'/form/category/condition/tree?type=1':url,
        };

        let res = await getCategoryListPost(data);

        return res.data;
      } else if (method == "get" || method == "GET") {
        let data = {
          current: obj.current,
          size: obj.size,
          url: url=='/form/category/condition/tree'||url=='form/category/condition/tree'?'/form/category/condition/tree?type=1':url,
        };

        let res = await getCategoryList(data);

        return res.data;
      }
    },

    //点击点位跳转
    btnPoint(item) {
      this.tableSecondIndex = -1;
      if (this.curPoint && this.curPoint.value == item.value) {
        this.curPoint = { value: "" };
        this.curSecondPoint = { value: "" };
        this.curThreePoint = { value: "" };
        this.value.linkPoint = null;
      } else {
        this.curPoint = item;
        this.value.linkPoint = {
          sign: item.sign,
          value: item.value,
          name: item.name,
          id: JSON.parse(this.curClickPage.linkPoints)[0]["id"],
        };

        if (item.slot) {
          this.value.linkPoint.slot = item.slot;
        } else {
          this.value.linkPoint.slot = "";
        }

        if (item.cvalue) {
          this.value.linkPoint.cvalue = item.cvalue;
        } else {
          this.value.linkPoint.cvalue = "";
        }

        this.curSecondPoint = {
          value: "",
        };
        this.value.linkPoint.secondTreeLinkPoint = {};
        this.curThreePoint = {
          value: "",
        };
        this.value.linkPoint.threeTreeLinkPoint = {};
      }
    },

    //点击二级导航点位
    btnPointSecond(item, index) {
      if (this.tableSecondIndex == index) {
        this.tableSecondIndex = -1;
        this.value.linkPoint.secondLinkPoint = {};
      } else {
        this.tableSecondIndex = index;
        this.value.linkPoint.secondLinkPoint = item;
        this.value.linkPoint.secondLinkPoint.id = this.secondLinkPointId;
      }
    },

    //点击树形二级导航点位
    btnPointSecondTree(item, childrenSign) {
      if (this.curSecondPoint && this.curSecondPoint.value == item[this.clickId]) {
        this.curSecondPoint = {
          value: "",
        };
        this.value.linkPoint.secondTreeLinkPoint = {};
        this.curThreePoint = {
          value: "",
        };
        this.value.linkPoint.threeTreeLinkPoint = {};
      } else {
        this.curSecondPoint = {
          value: item[this.clickId],
          name: item[this.showName],
          children: item[childrenSign] ? item[childrenSign] : [],
        };

        this.curThreePoint = {
          value: "",
        };
        this.value.linkPoint.threeTreeLinkPoint = {};

        this.value.linkPoint.secondTreeLinkPoint = {
          sign: this.clickId,
          value: item[this.clickId],
          name: item[this.showName],
          id: JSON.parse(this.curClickPage.linkPoints)[0]["id"],
        };
      }
    },

    //点击树形三级导航点位
    btnPointThreeTree(item, childrenSign) {
      if (this.curThreePoint && this.curThreePoint.value == item[this.clickId]) {
        this.curThreePoint = {
          value: "",
        };
        this.value.linkPoint.threeTreeLinkPoint = {};
      } else {
        this.curThreePoint = {
          value: item[this.clickId],
          name: item[this.showName],
          children: item[childrenSign],
        };

        this.value.linkPoint.threeTreeLinkPoint = {
          sign: this.clickId,
          value: item[this.clickId],
          name: item[this.showName],
          id: JSON.parse(this.curClickPage.linkPoints)[0]["id"],
        };
      }
    },

    //点击树节点
    handleCheckChange(data, checkedNode, relationField, index, params) {
      console.log("===handleCheckChange=== data:", JSON.stringify(data));
      console.log("===handleCheckChange=== checkedNode.checkedKeys:", checkedNode.checkedKeys);
      console.log("===handleCheckChange=== relationField:", relationField);
      console.log("===handleCheckChange=== index:", index);
      console.log("===handleCheckChange=== params:", JSON.stringify(params));
      console.log("===handleCheckChange=== data[relationField]:", data[relationField]);
      //多选
      if (params && params.multiValue) {
        let id = checkedNode.checkedKeys.join(",");
        console.log("===handleCheckChange=== multiValue, id:", id);
        this.btnClickParams(index, id);
      } else {
        //单选：check-on-click-node 已经切换过勾选状态，这里用 checkedNode 判断
        //checkedNode.checkedKeys 反映切换后的状态
        const isChecked = checkedNode.checkedKeys.includes(data[relationField]);
        console.log("===handleCheckChange=== isChecked:", isChecked);
        if (isChecked) {
          // 刚被勾选 → 单选模式只保留这一个
          console.log("===handleCheckChange=== 刚被勾选，调用 btnClickParams(index,", data[relationField], ")");
          if (this.$refs.tree && this.$refs.tree[index]) {
            this.$refs.tree[index].setCheckedKeys([data[relationField]]);
          }
          this.btnClickParams(index, data[relationField]);
        } else {
          // 刚被取消勾选
          console.log("===handleCheckChange=== 刚被取消勾选，调用 btnClickParams(index, '')");
          if (this.$refs.tree && this.$refs.tree[index]) {
            this.$refs.tree[index].setCheckedKeys([]);
          }
          this.btnClickParams(index, "");
        }
      }
    },

    //点击参数
    btnClickParams(index, id) {
      const componentId = this.dsInitParams[index].componentId;
      console.log("===btnClickParams=== START ====");
      console.log("===btnClickParams=== index:", index, "id:", JSON.stringify(id), "componentId:", componentId);
      console.log("===btnClickParams=== value.initParams before:", JSON.stringify(this.value.initParams));
      console.log("===btnClickParams=== dsInitParams[index]:", JSON.stringify(this.dsInitParams[index]));
      let index1 = -1;
      if (this.value.initParams) {
        index1 = this.value.initParams.findIndex(
            (item) =>
              item.componentId == componentId ||
              (item.componentId && item.componentId.indexOf(componentId) !== -1)
        );
      } else {
        this.value.initParams = [];
      }
      console.log("===btnClickParams=== index1 (found in initParams):", index1);

      // 取消/清空时移除已选项，避免提交空参数
      if (id === "" || id === null || id === undefined) {
        console.log("===btnClickParams=== id is empty/null/undefined, canceling selection");
        this.dsInitParams[index].curChoose = "";
        if (index1 !== -1) {
          console.log("===btnClickParams=== removing item at index1:", index1);
          this.value.initParams.splice(index1, 1);
          console.log("===btnClickParams=== 取消选中，splice后:", JSON.stringify(this.value.initParams));
        } else {
          console.log("===btnClickParams=== index1 is -1, nothing to remove from initParams");
        }
        console.log("===btnClickParams=== END ====");
        return;
      }

      this.dsInitParams[index].curChoose = id;
      const relationField = this.dsInitParams[index].relationField;
      const obj = {
        componentId: this.dsInitParams[index].componentId,
        relationField: relationField,
        name: this.dsInitParams[index].name,
      };
      obj[relationField] = id;
      console.log("===btnClickParams=== obj to add:", JSON.stringify(obj));
      if (index1 != -1) {
        //同一字段值相同 → 取消选中
        if (obj[relationField] == this.value.initParams[index1][relationField]) {
          console.log("===btnClickParams=== same value, removing existing item");
          this.value.initParams.splice(index1, 1);
          console.log("===btnClickParams=== 同一字段取消，splice后:", JSON.stringify(this.value.initParams));
        } else {
          console.log("===btnClickParams=== different value, replacing existing item");
          this.value.initParams[index1] = obj;
          console.log("===btnClickParams=== 替换值:", JSON.stringify(this.value.initParams));
        }
      } else {
        console.log("===btnClickParams=== no existing item, pushing new obj");
        this.value.initParams.push(obj);
        console.log("===btnClickParams=== 新增:", JSON.stringify(this.value.initParams));
      }
      console.log("===btnClickParams=== END ====");
    },

    // 开启
    open(val) {
      console.log("===JumpDialog open=== val:", JSON.stringify(val));
      console.log("===JumpDialog open=== val.initParams:", JSON.stringify(val.initParams));
      this.value = deepClone(val);
      this.value.type = val.type ? val.type : "insid";
      this.valueOld = deepClone(val);
      console.log("===JumpDialog open=== valueOld.initParams:", JSON.stringify(this.valueOld.initParams));
      console.log("===JumpDialog open=== deepClone value.initParams:", JSON.stringify(this.value.initParams));
      this.dialogVisible = true;
      this.getDataList();
    },

    // 获取table 列表
    getDataList() {
      this.queryForm.aid = this.project.aid;
      getFormPage(this.queryForm)
          .then((res) => {
            this.dataList = res.data.records;
            this.totalPage = res.data.total;

            if (this.value && this.value.type == "insid") {
              let index = this.dataList.findIndex((a) => a.pagesId == this.value.id);
              if (index != -1) {
                this.getPoints(this.dataList[index], true);
              } else {
                this.value.data = {};
                this.value.id = "";
                this.value.linkPoint = null;
                this.value.initParams = [];
                this.curPoint = { value: "" };

                this.curSecondPoint = { value: "" };
                this.curThreePoint = { value: "" };

                this.$forceUpdate();
              }
            } else if (!this.value.type) {
              this.value.type = "insid";
              this.value.data = {};
              this.value.id = "";
              this.value.linkPoint = null;
              this.value.initParams = [];
              this.curPoint = { value: "" };
              this.curSecondPoint = { value: "" };
              this.curThreePoint = { value: "" };
              this.$forceUpdate();
            }
          })
          .catch((err) => {
            this.$message.error(err.msg);
          });
    },

    // 行数据的 Key
    getRowKey(row) {
      //处理报错问题
      return row.pagesId || row.classId || row.courseId || row.categoryId;
    },

    // 选中
    btnClickRow(row) {
      let index = this.value.id.indexOf(row.pagesId);
      if (index !== -1) {
        this.value.data = {};
        this.value.id = "";
      } else {
        this.value.data = {
          aid: row.aid,
          home: row.home,
          name: row.name,
          pagesId: row.pagesId,
          sign: row.sign,
        };
        this.value.id = row.pagesId;
      }
    },

    // 请选择跳转页面
    changeTab(type) {
      if (this.value.type == type) return;

      this.$set(this.value, "type", type);
      this.$set(this.value, "id", "");
      this.$set(this.value, "data", {});
      this.$set(this.value, "linkPoint", null);
      this.$set(this.value, "initParams", []);

      if (type == "link" || type == "applet") {
        this.$set(this.value, "mode", "1");
      } else {
        this.$set(this.value, "mode", "");
      }
      this.$forceUpdate();

      if (type == "insid") {
        this.getDataList();
      }
    },

    // 每页数
    handleSizeChange(index, item, val) {
      this.getList(index, item, val, "size");
    },

    // 当前页
    handleCurrentChange(index, item, val) {
      this.getList(index, item, val, "current");
    },

    async getList(index, item, val, cate) {
      if (cate == "size") {
        this.dsInitParams[index].size = val;
        this.dsInitParams[index].current = 1;
      } else {
        this.dsInitParams[index].current = val;
      }

      if (item.method == "post" || item.method == "POST") {
        let data = {
          current: this.dsInitParams[index].current,
          size: this.dsInitParams[index].size,
          url: item.url=='/form/category/condition/tree'||item.url=='form/category/condition/tree'?'/form/category/condition/tree?type=1':item.url,
        };

        let res = await getCategoryListPost(data);

        this.dsInitParams[index].dataList = res.data.records;
        this.dsInitParams[index].pages = res.data.pages;
        this.dsInitParams[index].total = res.data.total;
      } else if (item.method == "get" || item.method == "GET") {
        let data = {
          current: this.dsInitParams[index].current,
          size: this.dsInitParams[index].size,
          url: item.url=='/form/category/condition/tree'||item.url=='form/category/condition/tree'?'/form/category/condition/tree?type=1':item.url,
        };

        let res = await getCategoryList(data);
        this.dsInitParams[index].dataList = deepClone(res.data.records);
        this.dsInitParams[index].pages = res.data.pages;
        this.dsInitParams[index].total = res.data.total;
      }
    },

    bindColse() {
      this.dialogVisible = false;
      console.log("===bindColse=== valueOld:", JSON.stringify(this.valueOld));
      console.log("===bindColse=== valueOld.initParams:", JSON.stringify(this.valueOld.initParams));
      // 取消时不保存，恢复旧值
      this.$emit("success", this.valueOld);
      // 恢复 value 到初始状态，确保下次打开弹窗时显示正确的勾选状态
      if (this.valueOld) {
        this.value = deepClone(this.valueOld);
        // 同步恢复 dsInitParams 中的 curChoose 属性
        if (this.dsInitParams && this.value.initParams) {
          this.dsInitParams.forEach((item) => {
            item.curChoose = "";
          });
          this.value.initParams.forEach((initParam) => {
            const index = this.dsInitParams.findIndex(
                (item) => item.componentId == initParam.componentId
            );
            if (index != -1) {
              const relationField = initParam["relationField"];
              this.dsInitParams[index].curChoose = initParam[relationField] || "";
            }
          });
        }
      }
      this.$forceUpdate();
    },

    bindConfirm() {
      console.log("===bindConfirm=== value:", JSON.stringify(this.value));
      console.log("===bindConfirm=== value.initParams:", JSON.stringify(this.value.initParams));
      console.log("===bindConfirm=== dsInitParams:", JSON.stringify(this.dsInitParams));
      this.dialogVisible = false;
      this.value.data = {
        aid: this.value.data.aid,
        home: this.value.data.home,
        name: this.value.data.name,
        pagesId: this.value.data.pagesId,
        sign: this.value.data.sign,
        jump: this.value.data.jump,
      };
      console.log("===bindConfirm=== emitting value:", JSON.stringify(this.value));


      this.$emit("success", this.value);
      this.$forceUpdate();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../scss/variable";

.pageContent {
  display: flex;
}

.left {
  width: 160px;
  font-size: 14px;
  border-right: 1px solid #ededed;

  .cur {
    background-color: rgba(239, 250, 255, 1);
    color: rgba(56, 148, 255, 1);
    height: 50px;
    line-height: 50px;
    white-space: nowrap;
    /* 防止文本换行 */
    overflow: hidden;
    /* 隐藏溢出的内容 */
    text-overflow: ellipsis;
    /* 显示省略符号来代表被修剪的文本 */
    text-indent: 10px;
  }

  .nor {
    height: 50px;
    line-height: 50px;
    color: #333;
    white-space: nowrap;
    /* 防止文本换行 */
    overflow: hidden;
    /* 隐藏溢出的内容 */
    text-overflow: ellipsis;
    /* 显示省略符号来代表被修剪的文本 */
    text-indent: 10px;
  }
}

.right {
  flex: 1;
  padding-left: 20px;
}

.list {
  display: flex;

  .tab {
    width: 100px;
    height: 30px;
    color: #979797;
    border: solid 1px #ebedf0;
    cursor: pointer;
  }

  .tab-active {
    color: $color-theme;
    border: solid 1px $color-theme;
    background: #e0edff;
  }
}

.first-leve {
  width: 100%;
  height: 33px;
  line-height: 33px;
  padding: 0 20px;
  cursor: pointer;
}

.active {
  color: #ffffff;
  background: rgb(0, 106, 255);
}

.active-Scon {
  color: rgb(56, 148, 255);
  background: rgb(239, 250, 255);
}

::v-deep .insidTab .el-table__header-wrapper .el-table__header .el-checkbox {
  // 找到表头那一行，然后把里面的复选框隐藏掉
  display: none !important;
}

.el-cascader-panel {
  width: 140px !important;
  border: none !important;
}

.el-cascader-menu__list {
  width: 140px !important;
  overflow: hidden;
}

::v-deep .el-cascader-menu {
  min-width: 140px !important;
}

.active {
  color: #fff;
  background: #409fee;
  padding: 3px 5px;
  border-radius: 3px;
  display: inline-block;
}

.normal {
  color: #101010;
  padding: 3px 5px;
  border-radius: 3px;
  margin-right: 10px;
  display: inline-block;
}

.cate {
  background: #f3f4f6;
  font-size: 14px;
  color: #333;
  padding: 10px 20px;
  margin-bottom: 15px;
  margin-right: 15px;
  border-radius: 3px;
  display: inline-block;
}

.curCate {
  color: #fff !important;
  background: #409fee !important;
}

.points-tit {
  margin-bottom: 20px;
  color: rgba(16, 16, 16, 1);
  font-size: 14px;
  font-family: PingFangSC-regular;
}

.insidTab .custom-cell {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  height: 20px;
}
</style>
